import { useT } from "@transifex/react";
import { useTestReviewContext } from "../../context/TestReviewContext";
import { getDateTimeFromMilliseconds, getReadableTimeFromTimeLimit } from "../../helpers/DateTime";
import useBreakpoints, { Breakpoint } from "../../hooks/useBreakpoints";

const TestReviewInfoHeader = () => {
    const t = useT();
    const { studentTestContent } = useTestReviewContext();
    const { getStyleBasedOnBreakpoint } = useBreakpoints();

    const dueDate = studentTestContent.dueDate ? getDateTimeFromMilliseconds(studentTestContent.dueDate) : null;
    const timeLimit = studentTestContent.timeLimit ? getReadableTimeFromTimeLimit(studentTestContent.timeLimit) : null;

    const t_dueDate = dueDate
        ? t("Deadline: {readableDateTime}", {
              _tags: "reviewTest,testInfo",
              readableDateTime: dueDate,
          })
        : t("No deadline set", { _tags: "reviewTest,testInfo" });

    const t_time = timeLimit
        ? t("Time: {timeLimit}", { _tags: "reviewTest,testInfo", timeLimit })
        : t("No time limit set", { _tags: "reviewTest,testInfo" });

    const titleSize = getStyleBasedOnBreakpoint(Breakpoint.MD, "text-xxl", "text-xl");
    const metaLayout = getStyleBasedOnBreakpoint(Breakpoint.MD, "flex-row items-center", "flex-col items-start");
    const showInlineSep = getStyleBasedOnBreakpoint(Breakpoint.MD, "inline", "hidden");

    return (
        <div className="w-full">
            <h2 className={`${titleSize} font-normal text-p6-grey-dark mb-xs break-words`}>
                {studentTestContent.name}
            </h2>
            <div className={`flex ${metaLayout} gap-x-s text-l text-p6-grey-dark`}>
                <span>{t_dueDate}</span>
                <span
                    className={showInlineSep}
                    aria-hidden="true"
                >
                    |
                </span>
                <span>{t_time}</span>
            </div>
        </div>
    );
};

export default TestReviewInfoHeader;
